import { Input } from '@mentalgrowth/ui-kit-web';
import type { TpInputProps } from '@mentalgrowth/ui-kit-web';
export const UiKitInput = (props: TpInputProps) => <Input {...props} data-sentry-element="Input" data-sentry-component="UiKitInput" data-sentry-source-file="index.tsx" />;